import { UseAxiosResult } from "axios-hooks";
import Cookies from "universal-cookie";
import formatUrl from "utils/formatUrl";

import config from "config";
import api from "config/urls/api";

import { UseSelectUserManagementApi } from "./setup";

const cookies = new Cookies();

export type ClientType =
  | "Unknown"
  | "ClientFreeTrial"
  | "ClientStartUp"
  | "ClientTest"
  | "ClientTestStartup"
  | "ClientProspect"
  | "ClientProd"
  | "CodatInternal"
  | "CodatSalesDemo"
  | "CodatQATest";

type ClientRole = "Administrator" | "Developer" | "Analyst" | "Onboarding";
export interface UserClientInfo {
  clientId: string;
  clientName: string;
  clientRole: ClientRole;
  clientType?: ClientType;
  expired: boolean;
  expiredDate?: string;
  clientLoginProviderEnabled: boolean;
  userId: string;
  deleteRequested: boolean;
  deleted: boolean;
}

export const useUserClientsQuery = (): UseAxiosResult<UserClientInfo[]> => {
  return UseSelectUserManagementApi<UserClientInfo[]>({
    url: formatUrl(api.select.clients.all),
    method: "GET",
  });
};

interface GetClientInfoProps {
  clientId: string;
}

export const useUserClientQuery = ({
  clientId,
}: GetClientInfoProps): UseAxiosResult<UserClientInfo> => {
  cookies.set(config.APP_CLIENT_COOKIE_NAME, clientId, {
    path: "/",
    domain: ".codat.io",
  });
  return UseSelectUserManagementApi<UserClientInfo>(
    {
      url: formatUrl(api.select.clients.one, { clientId }),
      method: "GET",
    },
    {
      manual: true,
    }
  );
};
